module.exports = __webpack_public_path__ + "img/active-layer9.01e2e8c0.png";